import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { useSidebarController } from '../../GlobalData';

export function DefaultNavbar() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const sidebarController = useSidebarController();
    // Close sidebar when window is resized to desktop size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768 && isSidebarOpen) {
                setIsSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isSidebarOpen]);

    return (
        <>
            {/* Main Navbar */}
            <div className="flex flex-row items-center justify-between px-4 sm:px-6 py-4 bg-white border-b border-gray-200 w-full flex-wrap">
                {/* Left: Logo, Title, Dropdown, & Search */}
                <div className="flex flex-row items-center gap-3 flex-wrap">
                    {/* Hamburger Menu for Mobile */}
                    <button
                        className="md:hidden ml-2 text-[#2B5C56]"
                        onClick={() => sidebarController.setSidebarState(!sidebarController.getSidebarState())}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>

                    {/* Logo */}
                    <Link
                        to={"/"}
                    >
                        <img src={new URL('./assets/logo.png', import.meta.url).href} className='w-[128px]' alt='GEJUR Logo' />
                    </Link>

                    {/* Desktop Dropdown Eksplore */}
                    <div className="relative group hidden md:block">
                        <button className="ml-2 sm:ml-4 border border-[#2B5C56] rounded-lg px-3 sm:px-4 py-1 text-[#2B5C56] bg-white text-sm sm:text-base outline-none flex items-center">
                            Eksplore
                            <svg className="ml-2 w-4 h-4" fill="none" stroke="#2B5C56" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>

                        {/* Dropdown Menu */}
                        <div className="absolute left-0 mt-2 w-96 bg-white border border-gray-200 rounded-lg shadow-lg p-6 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                            <h3 className="text-lg font-bold text-[#2B5C56] mb-4">Tranding skill</h3>
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg hover:bg-[#D4E9E6] cursor-pointer">
                                    <span className="font-medium text-[#2B5C56] text-sm">Phyton</span>
                                </div>

                                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg hover:bg-[#D4E9E6] cursor-pointer">
                                    <span className="font-medium text-[#2B5C56] text-sm">Excel</span>
                                </div>

                                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg hover:bg-[#D4E9E6] cursor-pointer">
                                    <span className="font-medium text-[#2B5C56] text-sm">Marketing</span>
                                </div>

                                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg hover:bg-[#D4E9E6] cursor-pointer">
                                    <span className="font-medium text-[#2B5C56] text-sm">Power BI</span>
                                </div>
                            </div>

                            <h3 className="text-lg font-bold text-[#2B5C56] mb-4">Categories</h3>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Development</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Business</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Finance & Accounting</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">IT & Software</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Personal Development</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Design</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Marketing</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Lifestyle</a>
                                <a href="#/" onClick={() => {
                                    sidebarController.setSidebarState(false);
                                }} className="text-[#2B5C56] hover:text-[#184D47] hover:underline text-sm p-2 rounded hover:bg-[#EBF5F4]">Photography & Video</a>
                            </div>
                        </div>
                    </div>

                    {/* Search (only shown on screens >= lg) */}
                    <div className="hidden lg:flex flex-row items-center border border-[#2B5C56] rounded-full w-64 sm:w-80 bg-white ml-4">
                        <input
                            type="text"
                            placeholder="Cari kursus..."
                            className="flex-1 px-5 py-2 bg-transparent outline-none text-[#2B5C56] rounded-full"
                        />
                        <button className="bg-[#2B5C56] rounded-full w-8 h-8 flex items-center justify-center mr-2">
                            <svg width="18" height="18" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="8" cy="8" r="7" />
                                <line x1="13" y1="13" x2="17" y2="17" />
                            </svg>
                        </button>
                    </div>

                    <img src={new URL('./assets/dikti.png', import.meta.url).href} className='w-[48px] ' alt='Dikti Logo' />
                    <img src={new URL('./assets/umn.png', import.meta.url).href} className='w-[48px] ' alt='UMN Logo' />
                    <img src={new URL('./assets/kehati.jpeg', import.meta.url).href} className='w-[48px] ' alt='Kehati Logo' />
                </div>

                {/* Right: Notification & Profile */}
                <div className="flex flex-row items-center justify-center gap-4 sm:gap-6 sm:mt-0">
                    {/* Notification */}
                    <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#2B5C56" strokeWidth="2">
                        <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0 1 18 14.158V11a6.002 6.002 0 0 0-4-5.659V5a2 2 0 1 0-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 1 1-6 0v-1m6 0H9" />
                    </svg>

                    {/* Profile */}
                    <button className="border border-[#2B5C56] rounded-full w-8 h-8 flex items-center justify-center" onClick={() => {
                        navigate("/profile")
                    }}>
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#2B5C56" strokeWidth="2">
                            <circle cx="12" cy="8" r="4" />
                            <path d="M4 20c0-4 4-7 8-7s8 3 8 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
}